import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const DocumentItems = () => {
  const tabtype = localStorage.getItem("PAGEData");
  const navigate = useNavigate();
  const pagetype = sessionStorage.getItem("type");
  const historyItems = JSON.parse(sessionStorage.getItem("Items"));
  // const reduxData = useSelector((state) => pagetype === "delivery" ? state.Delivery.DeliveryItems : state.Invoice.InvoiceItems);
  const selectedType = localStorage.getItem("PAGEData");
  const handleBackClick = () => {
    localStorage.setItem("PAGEData", selectedType);
    if (pagetype === "delivery") {
      navigate("/sales/deliveryHistory");
    } else {
      navigate("/sales/invoiceHistory");
    }
    sessionStorage.removeItem("Items");
    sessionStorage.removeItem("type");
  };

  return (
    <>
      <div className="checkback">
        <button className="SalesBackButton" onClick={handleBackClick}>
          <IoMdArrowRoundBack className="backicon" />
          <p className="item">Back</p>
        </button>
        <h6 className="item">
          {pagetype === "delivery"
            ? `DELIVERY - ${
                historyItems[0]?.status === "Closed"
                  ? "CLOSED"
                  : historyItems[0]?.status === "Open"
                  ? "DISPATCHED"
                  : "PICKLIST"
              }`
            : "INVOICE"}
        </h6>
      </div>
      {historyItems && historyItems.length > 0 ? (
        <div className="History-main-div animate-fade-in">
          <div className="order-info">
            <div className="order-header">
              <h2>Doc#{historyItems[0]?.order_No}</h2>
              <p
                className={`status-badge ${
                  historyItems[0].status === "Open" ? "open" : "close"
                }`}
              >
                {historyItems[0].status}
              </p>
            </div>
            <div className="details-row">
              <div className="labels">
                <div>Customer Code</div>
                {/* <div>Customer Name</div> */}
                <div>
                  {tabtype === "Loading" ?  "Order Date":"Posting Date"}
                </div>

                <div>{tabtype === "Loading" ? "Pick Date" : "Due Date"}</div>
                {pagetype === "delivery" && (
                  <>
                    <div>Address</div>
                    <div>Sales Order No</div>
                  </>
                )}
              </div>
              <div className="values">
                <div>{historyItems[0].card_Code}</div>
                {/* <div>{historyItems.card_Name}</div> */}
                <div>{historyItems[0]?.order_Date}</div>
                <div>{historyItems[0]?.delivery_Date}</div>
                {pagetype === "delivery" && (
                  <>
                    <div>{historyItems[0]?.delivery_Address}</div>
                    <div>
                      {" "}
                      <strong>{historyItems[0]?.salesOrder_Num}</strong>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>

          <div className="order-items">
            <h3>Items({historyItems.length})</h3>
            {historyItems.map((item, index) => (
              <div className="item-card" key={index}>
                <div className="item-card-content">
                  <div className="item-left">
                    <p>{item.item_Code}</p>
                    <p className="itemname">{item.item_Name}</p>
                    <p>
                      {" "}
                      UOM:{item.uom} &nbsp; Quantity:{item.qty}
                    </p>
                  </div>
                  <div className="item-right">
                    <p>Line Total</p>
                    <p>
                      Rs.
                      {item.line_Total?.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </p>
                    <p className="itemname">
                      Rs.
                      {item.item_Price.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                      (Per Qty)
                    </p>
                  </div>
                </div>
                <div className="item-details-row">
                  <p>Weight {item.weight} kg</p>
                  <p>Standard {item.ordered}</p>
                  <p>Net{item.commited} kg</p>
                </div>
              </div>
            ))}
          </div>

          <div className="order-notes">
            <h3>Notes</h3>
            <div className="details-row">
              <div className="labels">
                <div>Sales Employee</div>
                <div>Journal</div>
                <div>Remarks</div>
                {pagetype === "delivery" && <div>Vehicle No</div>}
              </div>
              <div className="values">
                <div>{historyItems[0].sales_Employee}</div>
                <div>{historyItems[0].journal}</div>
                <div>{historyItems[0].remarks || "-"}</div>
                {pagetype === "delivery" && (
                  <div>{historyItems[0]?.vehicle_Number || "-"}</div>
                )}
              </div>
            </div>
          </div>

          <div className="order-total">
            <h3>Total</h3>
            <div className="details-row">
              <div className="labels">
                <div>Total standard weight</div>
                <div>Total Net Weight</div>
                <div>Total Tax Amount</div>
                <div>Total Amount</div>
              </div>
              <div className="values">
                <div>
                  {Number(historyItems[0].standard_weight).toLocaleString()} kg
                </div>
                <div>
                  {Number(historyItems[0].net_Weight).toLocaleString()} kg
                </div>
                <div>
                  Rs.
                  {historyItems.length > 0
                    ? historyItems[0].total_Tax_Amount.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0.00"}
                </div>
                <div className="price-font">
                  Rs.
                  {historyItems.length > 0
                    ? historyItems[0].doc_Total?.toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    : "0.00"}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>No items to display</p>
      )}
    </>
  );
};

export default DocumentItems;
